import React, { useContext, useEffect, useState } from 'react'
import { css, cx } from 'linaria'
import Link from '../../../Core/Link'

const BrandImage = css`
   max-height: 2.5rem;
   min-height: 1.5rem;
   width: auto;
   height: auto;
   max-width: 10rem;
`
const BrandNameTextLinkWrapper = css`
   min-height: 2.5rem;
   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
`

const BrandNameText = css`
   color: black;
   line-height: normal;
   font-size: 1rem;
   font-family: var(--font-industry);
   letter-spacing: -0.3px;
   font-weight: 600;
`

const BrandLogoHandler = ({ brandLogo, brandLink, brandName }) => {
   if (brandLogo?.src && brandLink) {
      return (
         <Link to={brandLink}>
            <div className="pb-8">
               <img
                  className={cx(BrandImage)}
                  src={brandLogo?.src}
                  alt={brandLogo?.alt ?? 'logo-image'}
                  //   style={{ maxWidth: '100%', height: 'auto' }}
               />
            </div>
         </Link>
      )
   } else if (brandName && brandLink) {
      // If brandLogo is missing, return brnaName with link
      return (
         <div className={cx(BrandNameTextLinkWrapper)}>
            <Link to={brandLink} className="link link--vb">
               <span className={cx(BrandNameText)}>{brandName}</span>
            </Link>
         </div>
      )
   } else if (brandLogo?.src) {
      // If brandLink is missing, return just the image
      return (
         <div className="pb-8">
            <img
               className={cx(BrandImage)}
               src="https://verktygsboden.se/pub_images/thumbs/Ryobi.png"
               alt={brandLogo?.alt ?? 'logo-image'}
               //   style={{ maxWidth: '100%', height: 'auto' }}
            />
         </div>
      )
   } else {
      // If both brandLogo and brandLink are missing, return null(empty element)
      return <></>
   }
}

export default BrandLogoHandler
